const ctx = require.context('./', true, /\.dialog\.js$/)
const dialogConfig = {}

ctx.keys().forEach(item => {
    const obj = ctx(item)
    dialogConfig[obj.default.name] = obj.default
})


export default dialogConfig